// extracted by mini-css-extract-plugin
module.exports = {"PlatformFeatured":"PlatformFeatured_PlatformFeatured__3IB0A","logo":"PlatformFeatured_logo__3Im3J","tagLine":"PlatformFeatured_tagLine__3BU-t"};